import { LoginService } from "src/app/auth/login.service";
import { LoginServiceBase } from "src/app/auth/login.service.base";
import { ApiService } from "src/app/Services/api.service";
import { ApiServiceBase } from "src/app/Services/api.service.base";

const ProductionApi = [
  { provide: ApiServiceBase, useClass: ApiService },
  { provide: LoginServiceBase, useClass: LoginService }
]

export const environment = {
  production: false,
  bannerText: "DEV",
  serverBaseUrl: "https://node1-dev.frogparking.com",
  apiTarget: ProductionApi
};
